<div class="emperor-ui-parent-question-pool-selector-container">
  <bp-sdk-select-input
    [choices]="choices"
    [label]="label"
    (valueUpdate)="onValueUpdate($event)"
    [choiceId]="selectedChoiceId"
  ></bp-sdk-select-input>
  <emperor-button (click)="submit()">Next</emperor-button>
</div>
